import React, { useRef } from 'react';
import { message } from 'antd';
import { CameraOutlined, CloseCircleFilled } from '@ant-design/icons';

// A big, friendly photo picker: tap a giant camera tile to add photos,
// tap the X on a thumbnail to remove it. No drag-and-drop, no dialogs.
const SimpleImageDropzone = ({ files = [], onChange, maxCount = 10 }) => {
    const inputRef = useRef(null);

    const handleFiles = (fileList) => {
        const incoming = Array.from(fileList || []);
        const accepted = [];

        for (const file of incoming) {
            if (!file.type.startsWith('image/')) {
                message.error(`"${file.name}" is not a photo`);
                continue;
            }
            if (file.size / 1024 / 1024 > 10) {
                message.error(`"${file.name}" is too big (max 10MB)`);
                continue;
            }
            accepted.push(file);
        }

        if (accepted.length === 0) return;

        const next = [...files, ...accepted].slice(0, maxCount);
        if (files.length + accepted.length > maxCount) {
            message.warning(`You can add up to ${maxCount} photos`);
        }
        onChange(next);
    };

    const handleRemove = (index) => {
        onChange(files.filter((_, i) => i !== index));
    };

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
            {files.map((file, index) => (
                <div
                    key={index}
                    style={{
                        position: 'relative',
                        width: 96,
                        height: 96,
                        borderRadius: 16,
                        overflow: 'hidden',
                        border: '2px solid #e8f4f8',
                        flexShrink: 0
                    }}
                >
                    <img
                        src={URL.createObjectURL(file)}
                        alt="Selected"
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                    <button
                        type="button"
                        onClick={() => handleRemove(index)}
                        aria-label="Remove photo"
                        style={{
                            position: 'absolute',
                            top: 2,
                            right: 2,
                            border: 'none',
                            background: 'transparent',
                            padding: 0,
                            lineHeight: 0,
                            cursor: 'pointer'
                        }}
                    >
                        <CloseCircleFilled style={{ fontSize: 22, color: '#ff4d4f', filter: 'drop-shadow(0 0 2px white)' }} />
                    </button>
                </div>
            ))}

            {files.length < maxCount && (
                <button
                    type="button"
                    onClick={() => inputRef.current?.click()}
                    style={{
                        width: 96,
                        height: 96,
                        borderRadius: 16,
                        border: '2px dashed #91caff',
                        background: '#f0f7ff',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 4,
                        cursor: 'pointer',
                        flexShrink: 0
                    }}
                >
                    <CameraOutlined style={{ fontSize: 28, color: '#1890ff' }} />
                    <span style={{ fontSize: 12, color: '#1890ff', fontWeight: 600 }}>Add Photo</span>
                </button>
            )}

            <input
                ref={inputRef}
                type="file"
                accept="image/*"
                multiple
                capture="environment"
                style={{ display: 'none' }}
                onChange={(e) => {
                    handleFiles(e.target.files);
                    e.target.value = '';
                }}
            />
        </div>
    );
};

export default SimpleImageDropzone;
